export default __webpack_public_path__ + "static/media/g_wdt_c_1_2.de1e862c.mp3";